import {
  Button,
  Card,
  CardBody,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";
import React, { useEffect, useState } from "react";
import {
  getRakTransactionReceiptById,
  getTabRakTransactionsDetails,
  getTabRakTransactionsList,
} from "../../../../service/profile-ras-service";

import { DatePicker } from "antd";
import Loading from "../../../loader/loader.js";
import NkTable from "../../nktable";
import RaKTransactionFilter from "./../modals/tak-ransactions-filter";
import TransactionModal from "../modals/transactionmodal";
import awardImg from "assets/img/icons/common/award-badge.png";
import { message } from "antd";
import moment from "moment";
import {
  updateTransactionStatus,
  transactionRevrseService,
  transactionMarkSuccessService,
} from "../../../../service/rak-beneficiary-service";

const RakTransactionsTab = ({ userId, allUsersObject }) => {
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [tansactionModal, setTransactionModal] = useState(false);
  const [searchBy, setSearchBy] = useState("c3REF");
  const [searchByValue, setSearchByValue] = useState("");
  const [filterValues, setFilterValues] = useState(false);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState();
  const [dataLoading, setDataLoading] = useState(false);
  const [filtersSelected, setFiltersSelected] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");
  const [allUserList, setAllUserList] = useState([]);
  const [sizeShow, setSizeShow] = useState();
  const [type, setType] = useState([]);
  const [country, setCountry] = useState([]);
  const [status, setStatus] = useState([]);
  const [pagination, setPagination] = useState({
    pageSize: 10,
    total: 0,
    current: 1,
  });
  const [updateloading, setupdateloading] = useState(false);

  const [btnLoader, setBtnLoader] = useState({
    reverseLoading: false,
    markSuccessLoading: false,
  });

  const request = {
    page: 1,
    size: 10,
    beneficiaryName: "",
    receiver: "",
    fromDate: "",
    toDate: "",
    searchType: "",
    searchCountry: "",
    searchStatus: "",
    c3REF: "",
    rakref: "",
    isFilter: false,
    typeLength: "",
    countryLength: "",
    statusLength: "",
  };

  const [filterForm, setFilterForm] = useState(request);
  const [rakTab, setRakTab] = useState([]);

  const columns = [
    {
      dataField: "isEligibleForLoyalty",
      text: "Loyalty",
      sort: false,
      headerStyle: { textAlign: "center" },
      style: { width: "16px", textAlign: "center" },
      formatter: (cell, row) => {
        return row && row.isEligibleForLoyalty ? (
          <img title="Loyalty" style={{ width: "20px" }} src={awardImg} />
        ) : (
          "-"
        );
      },
    },
    {
      dataField: "action",
      text: "Action",
      sort: false,
      headerStyle: { textAlign: "center" },
      style: { width: "140px", textAlign: "center" },
      formatter: (cell, row) => {
        return (
          <>
            {row && row.id ? (
              <i
                className="ni ni-bag-17"
                style={{ fontSize: 20 }}
                onClick={() => {
                  setCurrentTransactionId(row.id);
                  getRakTransactionById(row.id);
                }}
              />
            ) : null}
          </>
        );
      },
    },
    {
      dataField: "createdDate",
      text: "Date",
      sort: true,
      style: { minWidth: "100px", textAlign: "Left" },
      formatter: (cell, row) => {
        // return moment((row && row.createdDate) || null).format("DD-MM-YY");
        return moment((row && row.createdDate) || null).format(
          "DD-MM-YY HH:mm:ss"
        );
      },
    },
    {
      dataField: "beneficiaryName",
      text: "Beneficiary",
      sort: false,
      style: { minWidth: "150px", textAlign: "left" },
    },
    {
      dataField: "country",
      text: "Country",
      sort: false,
      style: { minWidth: "100px", textAlign: "center" },
    },
    {
      dataField: "type",
      text: "Type",
      sort: false,
      headerStyle: { textAlign: "left" },
      style: { minWidth: "150px", textAlign: "left" },
    },

    {
      dataField: "sent",
      text: "Sent",
      sort: false,
      headerStyle: { textAlign: "cneter" },
      style: { minWidth: "100px", textAlign: "center" },
    },
    {
      dataField: "fee",
      text: "Fee",
      sort: false,
      headerStyle: { textAlign: "center" },
      style: { minWidth: "100px", textAlign: "center" },
    },

    {
      dataField: "c3REF",
      text: "C3 Ref",
      sort: false,
      headerStyle: { textAlign: "center" },
      style: { minWidth: "160px", textAlign: "center" },
    },
    {
      dataField: "rakref",
      text: "RAK Ref",
      sort: false,
      headerStyle: { textAlign: "center" },
      style: { minWidth: "160px", textAlign: "center" },
      formatter: (cell, row) => {
        console.log(row);
        return (
          <div>
            {row && row.rakref === "00000000-0000-0000-0000-000000000000"
              ? "N/A"
              : row.rakref}
          </div>
        );
      },
    },
    {
      dataField: "referralCode",
      text: "Code",
      sort: false,
      style: { minWidth: "100px", textAlign: "Left" },
      headerStyle: { textAlign: "Left" },
    },
    {
      dataField: "status",
      text: "Status",
      sort: false,
      headerStyle: { textAlign: "left" },
      style: { minWidth: "160px", textAlign: "left" },
    },
  ];

  const [transactionDetails, setTransactionDetails] = useState("");

  const [id, setId] = useState();

  useEffect(() => {
    if (userId) {
      setId(userId);
    }
  }, []);

  useEffect(() => {
    if (id) {
      getTabRakTransactionListDD(filterForm, id);
    }
  }, [id]);
  useEffect(() => {
    if (filterForm && filterForm.isFilter) {
      getTabRakTransactionListDD(filterForm, id);
    }
  }, [filterForm]);

  const getTabRakTransactionListDD = (request, id) => {
    setDataLoading(true);
    request["searchStatus"] =
      request && request.searchStatus && request.searchStatus.length == 0
        ? ""
        : request.searchStatus;
    request["searchType"] =
      request && request.searchType && request.searchType.length == 0
        ? ""
        : request.searchType;
    request["searchCountry"] =
      request && request.searchCountry && request.searchCountry.length == 0
        ? ""
        : request.searchCountry;
    request.size = sizeShow || 10;
    getTabRakTransactionsList(request, id)
      .then((res) => {
        console.log("RESPONSE", res.data.moneyTransferTransactions);

        setDataLoading(false);
        setRakTab(res.data.moneyTransferTransactions);
        setPagination({
          ...pagination,
          pageSize: sizeShow || 10,
          total: res.data.totalCount,
          current: request.page,
        });
      })
      .catch((err) => {
        setDataLoading(false);
        console.log(err);
        setRakTab([]); // TODO -NEED TO REMOVE
      });
  };

  const [currentTransactionId, setCurrentTransactionId] = useState();

  const getRakTransactionById = (id) => {
    getRakTransactionReceiptById(id)
      .then(async (res) => {
        console.log(res);

        await setTransactionDetails(res.data);
        await setTimeout(() => {}, 0);
        await setTransactionModal(true);
      })
      .catch((err) => {
        // message.error("Something went wrong");
        setTransactionModal(false);
        setCurrentTransactionId("");
        setTransactionDetails("");
      });
  };

  const updateStatusClicked = () => {
    setupdateloading(true);
    console.log("updateStatusClicked", currentTransactionId);
    updateTransactionStatus(currentTransactionId)
      .then(async (res) => {
        console.log(res);
        setupdateloading(false);

        await setTransactionModal(false);
        await getRakTransactionById(currentTransactionId);
      })
      .catch((err) => {
        setupdateloading(false);
        console.log(err);
        // message.error("something went wrong");
      });
  };

  const transactionReverseOnclick = (referenceNumber) => {
    setBtnLoader({ ...btnLoader, reverseLoading: true });
    transactionRevrseService(referenceNumber)
      .then(async (res) => {
        console.log(res);
        setBtnLoader({ ...btnLoader, reverseLoading: false });

        // await setTransactionModal(false);
        getRakTransactionById(currentTransactionId);
      })
      .catch((err) => {
        setBtnLoader({ ...btnLoader, reverseLoading: false });
      });
  };

  const transactionMarkSuccessOnclick = (referenceNumber) => {
    setBtnLoader({ ...btnLoader, markSuccessLoading: true });
    transactionMarkSuccessService(referenceNumber)
      .then(async (res) => {
        console.log(res);
        setBtnLoader({ ...btnLoader, markSuccessLoading: false });

        // await setTransactionModal(false);
        getRakTransactionById(currentTransactionId);
      })
      .catch((err) => {
        setBtnLoader({ ...btnLoader, markSuccessLoading: false });
      });
  };

  const handleFilter = () => {
    let request = {};
    if (searchBy === "beneficiary") {
      request = {
        ...filterForm,
        beneficiaryName: searchByValue,
        c3REF: "",
        rakref: "",
      };
    } else if (searchBy === "c3REF") {
      request = {
        ...filterForm,
        beneficiaryName: "",
        c3REF: searchByValue,
        rakref: "",
      };
    } else if (searchBy === "rakref") {
      request = {
        ...filterForm,
        beneficiaryName: "",
        c3REF: "",
        rakref: searchByValue,
      };
    } else if (searchBy === "Code") {
      request = {
        ...filterForm,
        beneficiaryName: "",
        c3REF: "",
        referralCode: searchByValue,
      };
    }
    if (filterForm.searchCountry && filterForm.searchCountry.length > 0) {
      let a = "";
      filterForm.searchCountry.forEach((v, i) => {
        console.log(v);
        a = a + v.value + (i + 1 < filterForm.searchCountry.length ? "," : "");
      });
      request.searchCountry = a || "";
    } else {
      request.searchCountry = filterForm.searchCountry || "";
    }

    if (filterForm.searchStatus && filterForm.searchStatus.length > 0) {
      let a = "";
      filterForm.searchStatus.forEach((v, i) => {
        console.log(v);
        a = a + v.value + (i + 1 < filterForm.searchStatus.length ? "," : "");
      });
      request.searchStatus = a || "";
    } else {
      request.searchStatus = filterForm.searchStatus || "";
    }

    if (filterForm.searchType && filterForm.searchType.length > 0) {
      let a = "";
      filterForm.searchType.forEach((v, i) => {
        console.log(v);
        a = a + v.value + (i + 1 < filterForm.searchType.length ? "," : "");
      });
      request.searchType = a || "";
    } else {
      request.searchType = filterForm.searchType || "";
    }

    request.fromDate =
      (fromDate && moment(fromDate).format("YYYY-MM-DD")) || null;
    request.toDate =
      (toDate && moment(toDate).format("YYYY-MM-DD")) || moment().format();
    request.searchFilter = "";
    request.page = 1;
    request.isFilter = true;

    setFilterForm(request);
  };

  let searchByValuePlaceholder = "";
  if (searchBy === "c3REF") {
    searchByValuePlaceholder = "RMTxxxxxxxxx";
  } else if (searchBy === "rakref") {
    searchByValuePlaceholder = "12345";
  } else if (searchBy === "Code") {
    searchByValuePlaceholder = "AB345";
  } else {
    searchByValuePlaceholder = "Amit Pandit";
  }

  const resetFilter = () => {
    request.isFilter = true;
    setType([]);
    setStatus([]);
    setCountry([]);
    setSearchBy("c3REF");
    setFilterForm(request);
    setSearchByValue("");
    setRakTab([]);
    setFromDate("");
    setToDate("");
    setSelectedOption([]);
    setFilterValues(false);
    setFilterForm(request);
  };

  const clearFilter = () => {
    setFilterForm({
      ...filterForm,
      searchType: "",
      searchCountry: "",
      searchStatus: "",
      typeLength: 0,
      countryLength: 0,
      statusLength: 0,
      totalLength: 0,
    });
    setType([]);
    setStatus([]);
    setCountry([]);
  };
  const dateFormat = "DD-MM-YY";
  const customFormat = (value) => `${value.format(dateFormat)}`;
  console.log("rak", rakTab);
  return (
    <>
      <Form>
        <Row
          style={{ marginLeft: "0px", marginRight: "0px", padding: "12px 0px" }}
        >
          <Col lg="2" className="form-input-padding-tab">
            <FormGroup>
              <label
                className="form-control-label"
                htmlFor="exampleFormControlSelect1"
              >
                Search by
              </label>
              <Input
                id="exampleFormControlSelect1"
                type="select"
                style={{ height: "28px" }}
                value={searchBy}
                onChange={(e) => {
                  setSearchByValue("");
                  setSearchBy(e.target.value);
                }}
              >
                <option value="c3REF">C3Ref </option>
                <option value="Code">Referral Code</option>
                <option value="rakref">RAK Ref</option>
                <option value="beneficiary">Beneficiary</option>
              </Input>
            </FormGroup>
          </Col>
          <Col lg="2" className="form-input-padding-tab">
            <FormGroup>
              <label
                className="form-control-label"
                htmlFor="example3cols2Input"
              >
                Search for
              </label>
              <Input
                id="example3cols2Input"
                placeholder={searchByValuePlaceholder}
                type="text"
                style={{ height: "27px" }}
                onChange={(e) =>
                  setSearchByValue(
                    e.target && e.target.value && e.target.value.trim()
                  )
                }
                value={searchByValue}
              />
            </FormGroup>
          </Col>
          <Col lg="2" className="form-input-padding-tab">
            <FormGroup>
              <Label
                className="form-control-label"
                htmlFor="example3cols2Input"
              >
                From
              </Label>
              <DatePicker
                placeholder="DD-MM-YY"
                className="formcontrol-date"
                onChange={(e, dateString) => {
                  if (dateString && dateString != "") {
                    setFromDate(moment(dateString, dateFormat));
                  } else {
                    setFromDate(null);
                  }
                }}
                value={fromDate}
                format={customFormat}
              />
            </FormGroup>
          </Col>
          <Col lg="2" className="form-input-padding-tab">
            <FormGroup>
              <Label
                className="form-control-label"
                htmlFor="example3cols2Input"
              >
                To
              </Label>
              <DatePicker
                placeholder="DD-MM-YY"
                className="formcontrol-date"
                onChange={(e, dateString) => {
                  if (dateString && dateString != "") {
                    setToDate(moment(dateString, dateFormat));
                  } else {
                    setToDate(null);
                  }
                }}
                value={toDate}
                format={customFormat}
              />
            </FormGroup>
          </Col>
          <Col
            lg="1"
            className="form-input-padding-tab"
            style={{ marginTop: "2px" }}
          >
            <FormGroup>
              <Label
                className="form-control-label"
                htmlFor="exampleFormControlSelect1"
              >
                Filter by
              </Label>
              <div>
                <Button
                  style={{ width: "100%", height: "26px" }}
                  color="primary"
                  type="button"
                  id="example3cols2Input"
                  className="filter-button"
                  onClick={() => setShowFilterModal(true)}
                >
                  <div>
                    {" "}
                    <i className="fas fa-filter"></i>
                  </div>
                </Button>
              </div>
            </FormGroup>

            <span style={{ fontSize: 8 }}>
              {filterForm && filterForm.totalLength > 0 ? (
                <>
                  <h6 style={{ display: "flex", alignItems: "center" }}>
                    selected(
                    {filterForm.totalLength}
                    )
                    <i
                      className="fas fa-window-close"
                      style={{ cursor: "pointer", paddingLeft: "5px" }}
                      onClick={() => clearFilter()}
                    />
                  </h6>
                </>
              ) : (
                <></>
              )}
            </span>
          </Col>
          <Col
            lg="1"
            style={{ marginTop: "9px" }}
            className="form-input-padding-tab"
          >
            <FormGroup>
              <Label
                className="form-control-label"
                htmlFor="example3cols2Input"
              ></Label>
              <div>
                <Button
                  // color="#e91d24"
                  type="button"
                  style={{
                    width: "100%",
                    background: "#e91d24",
                    color: "white",
                    height: "26px",
                    border: "1px solid rgb(233, 29, 36)",
                  }}
                  id="example3cols2Input"
                  className="filter-button"
                  onClick={() => handleFilter(true)}
                >
                  <div>
                    <i className="fas fa-search"></i>
                  </div>
                </Button>
              </div>
            </FormGroup>
          </Col>
          <Col
            lg="1"
            style={{ marginTop: "9px" }}
            className="form-input-padding-tab"
          >
            <FormGroup>
              <Label
                className="form-control-label"
                htmlFor="example3cols2Input"
              ></Label>
              <div>
                <Button
                  color="light"
                  type="button"
                  style={{ width: "100%", height: "26px" }}
                  id="example3cols2Input"
                  className="filter-button"
                  onClick={() => resetFilter()}
                >
                  <div
                    style={{
                      fontSize: "12px",
                    }}
                  >
                    {" "}
                    <i className="fas fa-redo-alt 2px"></i> Reset
                  </div>
                </Button>
              </div>
            </FormGroup>
          </Col>
        </Row>
      </Form>
      {rakTab.length < 0 ? (
        <>
          <Card
            className="mb-4"
            style={{
              display: "flex",
              flex: 1,
              textAlign: "center",
              justifyContent: "center",
              padding: "1.25rem 1.5rem",
            }}
          >
            <CardBody>
              <h3 className="mb-0">No Records Found</h3>
              {/* <h1 className="mb-0">Sorry ! We cannot find it</h1>
              <h3 className="mb-0">
                Enter a different search term or remove any filters and try
                again
              </h3> */}
            </CardBody>
          </Card>
        </>
      ) : (
        <>
          <Row style={{ padding: "1.25rem 0.5rem" }}>
            <div className="col card-parent">
              <Card>
                {dataLoading ? (
                  <div style={{ textAlign: "center" }}>
                    <Loading />
                  </div>
                ) : (
                  <>
                    <NkTable
                      filename={"All-User-List"}
                      data={rakTab}
                      columns={columns}
                      pagination={pagination}
                      onPagechange={(page) => {
                        setFilterForm({
                          ...filterForm,
                          page: page,
                          isFilter: true,
                        });
                      }}
                      showSizeChanged={(pageSize) => {
                        setSizeShow(pageSize);
                        setFilterForm({
                          ...filterForm,
                          isFilter: true,
                        });
                      }}
                    />
                  </>
                )}
              </Card>
            </div>
          </Row>
        </>
      )}
      <RaKTransactionFilter
        show={showFilterModal}
        country={country}
        setCountry={setCountry}
        type={type}
        setType={setType}
        status={status}
        setStatus={setStatus}
        onHide={() => {
          setShowFilterModal(false);
        }}
        saveButtonClicked={(saveResponse) => {
          setFilterForm({ ...filterForm, ...saveResponse, isFilter: false });
          setShowFilterModal(false);
        }}
      />
      <TransactionModal
        allUsersObject={allUsersObject}
        transactionDetails={transactionDetails}
        show={tansactionModal}
        updateStatusClicked={updateStatusClicked}
        reverseClickHandler={transactionReverseOnclick}
        markSuccessClickHandler={transactionMarkSuccessOnclick}
        btnLoader={btnLoader}
        updateloading={updateloading}
        onHide={() => {
          setCurrentTransactionId("");
          setTransactionModal(false);
        }}
      />
    </>
  );
};
export default RakTransactionsTab;
